import { useIsClient } from 'src/hooks/useIsClient'
import { sanitizeProductCustomHtml } from 'src/utils/sanitizeProductCustomHtml'

function decodeUriEncodedHtml(rawHtml: string): string {
  const trimmedHtml = rawHtml.trimStart()

  if (!/^%3c/i.test(trimmedHtml)) {
    return rawHtml
  }

  try {
    return decodeURIComponent(rawHtml)
  } catch {
    return rawHtml
  }
}

function normalizeEscapedHtml(rawHtml: string): string {
  const hasEscapedQuotes = /\\["']/.test(rawHtml)
  const hasHtmlTag = /<\/?[a-z][^>]*>/i.test(rawHtml)

  if (!hasEscapedQuotes || !hasHtmlTag) {
    return rawHtml
  }

  return rawHtml
    .replace(/\\r\\n|\\n|\\r/g, '\n')
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .replace(/\\\//g, '/')
}

export function HTMLContent({ html }: { html: string }) {
  const isClient = useIsClient()

  if (!isClient || typeof html !== 'string' || !html.trim()) {
    return null
  }

  const MORE_TAGS = ['svg', 'path', 'picture', 'source', 'video']
  const MORE_ATTRS = [
    'opacity',
    'fill',
    'stroke',
    'd',
    'viewBox',
    'stroke-dasharray',
    'stroke-width',
    'stroke-linecap',
    'media',
    'poster',
    'controls',
    'autoplay',
    'muted',
    'loop',
    'playsinline',
    'preload',
  ]

  const decodedHtml = decodeUriEncodedHtml(html)
  const normalizedHtml = normalizeEscapedHtml(decodedHtml)
  const sanitizedHtml = sanitizeProductCustomHtml(
    normalizedHtml,
    MORE_TAGS,
    MORE_ATTRS
  )

  if (!sanitizedHtml) {
    return null
  }

  return (
    <>
      <div
        className="html-content"
        dangerouslySetInnerHTML={{ __html: String(sanitizedHtml) }}
      />
    </>
  )
}
